"use strict";

var _inherits = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _classCallCheck = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var eth_sdk_1 = require("eth-sdk");

var utils_1 = require("../utils");

var AuthKeyModule = /*#__PURE__*/function () {
  function AuthKeyModule() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, AuthKeyModule);

    var privateKey = options.privateKey;

    if (privateKey) {
      if (!eth_sdk_1.verifyPrivateKey(privateKey)) {
        throw new Error('invalid private key');
      }

      this.key = new eth_sdk_1.Key(privateKey);
    } else {
      this.key = eth_sdk_1.Key.createRandom();
    }

    var address = this.key.address;
    this.state$ = new AuthKeyModule.State({
      address: address
    });
  }

  _createClass(AuthKeyModule, [{
    key: "signPersonalMessage",
    value: function signPersonalMessage(message) {
      return this.key.signPersonalMessage(message);
    }
  }, {
    key: "signTypedMessage",
    value: function signTypedMessage(message) {
      return this.key.signTypedMessage(message);
    }
  }, {
    key: "exportPrivateKey",
    value: function exportPrivateKey() {
      return this.key.privateKey;
    }
  }, {
    key: "state",
    get: function get() {
      return this.state$.getValue();
    }
  }, {
    key: "address",
    get: function get() {
      return this.state.address;
    }
  }]);

  return AuthKeyModule;
}();

exports.AuthKeyModule = AuthKeyModule;

(function (AuthKeyModule) {
  var State = /*#__PURE__*/function (_utils_1$StateSubject) {
    _inherits(State, _utils_1$StateSubject);

    var _super = _createSuper(State);

    function State(state) {
      var _this;

      _classCallCheck(this, State);

      _this = _super.call(this, state);
      _this.address$ = _this.getSubSubject('address');
      return _this;
    }

    return State;
  }(utils_1.StateSubject);

  AuthKeyModule.State = State;
})(AuthKeyModule = exports.AuthKeyModule || (exports.AuthKeyModule = {}));